module.exports = __webpack_public_path__ + "static/media/chambre-anti-allergie.438f704f.svg";